import { createAction, props } from '@ngrx/store';

import { Availability } from '../../../objects/availability';
import { DateOfStay } from '../../../objects/date-of-stay';
import { Destination } from '../../../objects/destination';
import { Product } from '../../../objects/product';
import { Order } from '../../../objects/order';

export const loadAvailabilities = createAction(
  '[Availabilities] LoadAvailabilities',
  props<{product: Product; destination: Destination; dateOfStay: DateOfStay}>(),
);

export const loadAvailabilitiesSuccess = createAction(
  '[Availabilities] LoadAvailabilitiesSuccess',
  props<{availabilities: Availability[]}>(),
);

export const loadAvailabilitiesFailure = createAction(
  '[Availabilities] LoadAvailabilitiesFailure',
  props<{error: Error}>(),
);

export const setSelectedAvailabilities = createAction(
  '[Availabilities] SetSelectedAvailabilities',
  props<{
    product: Product;
    destination: Destination;
    dateOfStay: DateOfStay;
    order: Order;
    availabilities: Availability[]
  }>(),
);
